import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { Modal, Button, Row, Col, notification } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FormularioTerminal from '../app/features/FormularioTerminal';
import useTerminalEmissor from '../core/hooks/useTerminalEmissor';
import FormularioTerminalComercial from '../app/features/FormularioTerminalComercial';
import LojaService from '../sdk/services/Loja.service';

const ModalTerminalComercial = (props: {
  terminalComercial: any;
  quandoFinalizar: () => any;
  terminaisFiscais:any;
}) => {
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState('Form de cadastro de terminais');
  const [showCreationModal, setShowCreationModal] = useState(false);
  const openCreationModal = useCallback(() => setShowCreationModal(true), []);
  const closeCreationModal = useCallback(() => setShowCreationModal(false), []);
  const parametroUrl = useParams<{ id: string }>();




  return (
    <>
      <Row align={'middle'} gutter={24}>
        <Col xs={24} lg={12}>
          <Button size='small' icon={<EditOutlined />} onClick={openCreationModal} />
        </Col>
      </Row>
      <Modal
        title='Terminal Comercial'
        footer={null}
        visible={showCreationModal}
        onCancel={closeCreationModal}
        destroyOnClose
      >
        <FormularioTerminalComercial
          onSuccess={() => {
            closeCreationModal();
            props.quandoFinalizar();
            notification.success({
              message: 'Terminal Editado com sucesso',
              top: 80,
            });
          }}
          terminalComercial={props.terminalComercial}
          terminaisFiscais={props.terminaisFiscais}
        ></FormularioTerminalComercial>
      </Modal>
    </>
  );
};

export default ModalTerminalComercial;
